module.exports = __webpack_public_path__ + "static/media/logo.6ef6ab70.svg";